import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "hyphenate"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIBreakString(_ref) {
  let {
      children,
      className,
      hyphenate
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    className: classNames('private-break-string', className, hyphenate ? 'private-break-string--hyphenate' : 'private-break-string--no-hyphenate'),
    children: children
  }));
}
UIBreakString.propTypes = {
  children: PropTypes.node.isRequired,
  hyphenate: PropTypes.bool
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIBreakString.defaultProps = {
  hyphenate: true
};
UIBreakString.displayName = 'UIBreakString';